import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  plugins: [createPersistedState()],
  state: {
    token: "",
    isAuth: false,
  },
  getters: {
    loginToken: (state) => {
      return state.token;
    },
    loginAuth: (state) => {
      return state.isAuth;
    },
  },
  mutations: {
    UPDATE_TOKEN(state, token) {
      state.token = token;
    },
    UPDATE_LOGOUT(state) {
      state.token = "";
      state.isAuth = false;
    },
    UPDATE_IS_AUTH(state, auth) {
      state.isAuth = auth;
    },
  },
  actions: {
    CREATE_TOKEN({ commit }, toke) {
      commit("UPDATE_TOKEN", toke);
    },
    CREATE_LOGOUT({ commit }, dec) {
      commit("UPDATE_LOGOUT", dec);
    },
    CREATE_IS_AUTH({ commit }, aux) {
      commit("UPDATE_IS_AUTH", aux);
    },
  },
  modules: {},
});
export default store;
